import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import { gridRemoveDeal } from 'actions/grid'
import { getSellableItems } from 'selectors/grid'
import { toDecimal } from 'utils/decimal'

import GridCellDeal from './grid-cell-deal'

import styles from './grid-cell-deal.css'

export class GridCellDealContainer extends Component {

  constructor(props) {
    super(props)

    this.onRemove = this.onRemove.bind(this)
  }

  onRemove() {
    this.props.gridRemoveDeal(this.props.dateId, this.props.timeId, this.props.deal.id)
  }

  render() {
    const { deal, sellableItems } = this.props
    const sellableItem = sellableItems.get(deal.sellableItemId)
    const canRemove = deal.soldTickets === 0

    const dealPriceOverriden = !!deal.discountPrice

    const discountPrice = dealPriceOverriden ? toDecimal(deal.discountPrice) : toDecimal(sellableItem.salePrice)
    const initialPrice = dealPriceOverriden ? toDecimal(deal.initialPrice) : toDecimal(sellableItem.faceValue)
    const bookingFee = (discountPrice > initialPrice) ? (discountPrice - initialPrice).toString() : null
    const showInitialPrice = initialPrice > discountPrice
    const isPriceDifferent = !!deal.discountPrice && sellableItem.salePrice !== deal.discountPrice

    const props = {
      deal,
      sellableItem,
      canRemove,
      onRemove: this.onRemove,
      isOnsale: deal.isOnsale,
      isPriceDifferent,
      discountPrice,
      initialPrice,
      bookingFee,
      showInitialPrice,
    }
    return (
      <GridCellDeal {...props} />
    )
  }
}
GridCellDealContainer.propTypes = {
  dateId: PropTypes.string.isRequired,
  deal: PropTypes.object.isRequired,
  gridRemoveDeal: PropTypes.func.isRequired,
  sellableItems: PropTypes.object.isRequired,
  timeId: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  sellableItems: getSellableItems(state),
})

const mapDispatchToProps = {
  gridRemoveDeal,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(GridCellDealContainer, styles))



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-cell-deal/grid-cell-deal-container.js
 **/